module.exports = __webpack_public_path__ + "img/pad.18dbbece.png";